export default "__VITE_ASSET__B9tck27w__"